import { opFor, type LevelId } from '../../data/ids';
import type { ResolvedLevel } from '../../data/load-level';
import type { LevelEnding } from '../../data/types';

export interface RouteMark {
  id: string;
  /** Position along the route, 0..1 (x / level length). */
  at: number;
}

export interface BriefingModel {
  levelId: LevelId;
  op: string;
  marks: RouteMark[];
  /** How the route ends (GDD §10.2); null when the level is not built yet. */
  ending: LevelEnding | null;
  /** Unique enemy types of the level, ordered by ID ("EN-01", "EN-02"...). */
  threats: string[];
  /** The level has data in src/data: only then "Desplegar" is enabled (GDD §10.1). */
  deployable: boolean;
  /** The saved checkpoint the deployment resumes from (GDD §6.3), or null for the start. */
  resume: string | null;
}

/**
 * Everything BRIEFING shows, derived from the level data (GDD §13.2, issue #57): the route map with one
 * mark per checkpoint, the ending and the known threats. `level` is null for an operation whose level is
 * not built yet; `resume` is the checkpoint saved in the slot for this same level.
 */
export function briefingModel(levelId: LevelId, level: ResolvedLevel | null, resume: string | null = null): BriefingModel {
  return {
    levelId,
    op: opFor(levelId),
    marks: level ? level.checkpoints.map(({ id, x }) => ({ id, at: x / level.length })) : [],
    ending: level?.def.ending ?? null,
    threats: level ? [...new Set(level.enemies.map((enemy) => enemy.type))].sort() : [],
    deployable: level !== null,
    resume: level && resume && level.checkpoints.some((checkpoint) => checkpoint.id === resume) ? resume : null,
  };
}
